import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  verifyEmail: {
    id: 'studio.FBt1Ti',
    defaultMessage:
      'Please verify your email address ({email}) to complete your Appsemble registration.',
  },
});
